import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {path: "/", name: "ViewMain", component: () => import("../views/ViewMain.vue")},
    {path: "/notice", name: "ViewNotice", component: () => import("../views/ViewNotice.vue")},
    {path: "/intro", name: "ViewIntro", component: () => import("../views/ViewIntro.vue")},
    {path: "/success", name: "ViewSuccess", component: () => import("../views/ViewSuccess.vue")},
    {path: "/service", name: "ViewService", component: () => import("../views/ViewServiceUse.vue")},
    {path: "/privacy", name: "ViewPrivacy", component: () => import("../views/ViewPrivacy.vue")},
    {path: "/review", name: "ViewReview", component: () => import("../views/ViewReview.vue")},
    {path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("../views/error/NotFound.vue")},
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: async (to) => {
    if (to.hash) {
      await new Promise(resolve => setTimeout(resolve, 100))
  
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  }
});

export default router;
